export class BrmInventoryErrors {

  public static INVENTORY_PL_SIZE_CLASH: string = 'ass028';
  public static INVENTORY_PL_SHORTCODE_CLASH: string = 'ass027';
  public static INVENTORY_INVALID_STATUS_CHANGE: string = 'ass024'; // happens when changing from broken to another state without servicing

}
